import { BaseErrorModel } from "@/models/core.model";
import React from "react";
import { Message, toaster } from "rsuite";
import { TypeAttributes } from "rsuite/esm/@types/common";
import { PlacementType } from "rsuite/esm/toaster/ToastContainer";

interface toastMessageParam {
    message?: string | React.ReactNode, 
    type?: TypeAttributes.Status, 
    duration?: number,
    closable?: boolean,
    placement?: PlacementType
}

export default function toastMessage( msg: toastMessageParam ){
    const {message, type, closable, placement, duration} = msg;
    toaster.push(
        <Message showIcon type={type ?? 'info'} closable={closable ?? true}>
            {message ?? type}
        </Message>, 
        { placement: placement ?? 'topEnd', duration: duration ?? 3000 }
    );
}

export function toastErrorMessage(
  messageOrModel?: string | BaseErrorModel,
  duration?: number,
  closable?: boolean,
  placement?: PlacementType
) {
  // Handle BaseErrorModel
  if (typeof messageOrModel === "object") {
    const model = messageOrModel;

    const errorMessage = model.errorMessage ?? "An unexpected error occurred.";
    const errors = model.errors ?? {};
    const fieldErrors: string[] = [];

    for (const key in errors) {
      if (errors.hasOwnProperty(key)) {
        errors[key].forEach(e => fieldErrors.push(`${key}: ${e}`));
      }
    }

    // Combine everything into one toast text
    const fullMessage = <p> {errorMessage} <br/>
        {fieldErrors.map(e => <span key={e}>{e}<br/></span>)}
    </p>;
      

    return toastMessage({
      message: fullMessage,
      type: "error",
      closable,
      placement,
      duration: duration ?? 5000,
    });
  }

  // Handle normal string version (original implementation)
  return toastMessage({
    message: messageOrModel,
    type: "error",
    closable,
    placement,
    duration: duration ?? 5000,
  });
}

export function toastSuccessMessage(    
    message?: string, 
    duration?: number,
    closable?: boolean,
    placement?: PlacementType
){
    return toastMessage({
        message: message,
        type: 'success',
        closable: closable ?? false,
        placement: placement,
        duration: duration ?? 3000
    });
}